import "./SwitchControlKm.css";
import Form from "react-bootstrap/Form";

export const SwitchControlKm = ({ controlkm, setModalControlShow }) => {
  const handleChange = (event) => {
    setModalControlShow(true, !controlkm);
  };

  return (
    <Form.Check // prettier-ignore
      type="switch"
      id="switch-km"
      label="Activar control de km"
      style={{ float: "right" }}
      checked={controlkm}
      onChange={(e) => handleChange(e)}
    />
  );
};
